<template>
  <div
    class="h-full w-full relative"
    :class="{
      'overflow-hidden':
        !isClient && (breakpoints || (slidesPerView && slidesPerView > 1)),
    }"
  >
    <div
      v-if="!isClient && (breakpoints || (slidesPerView && slidesPerView > 1))"
      class="absolute min-w-full z-10 bg-body-bg flex min-h-fit h-full overflow-hidden gap-4"
      :class="swiperBg"
    >
      <div
        v-for="index in 5"
        :key="index"
        class="rounded-[15px] h-[280px] loading-content min-w-[250px] w-full"
      />
    </div>
    <Swiper
      :key="layoutSize || 0"
      class="max-md:!overflow-visible"
      :class="class"
      :style="swiperStyle"
      :space-between="spaceBetween"
      :slides-per-view="slidesPerView"
      :navigation="navigation"
      :modules="modules"
      :loop="loop"
      :effect="effect"
      :autoplay="autoplay"
      :breakpoints="breakpoints"
      :direction="direction"
      :pagination="pagination"
      :mousewheel="mousewheel"
      @slide-change="emit('slide-change', $event)"
      @swiper="emit('swiper', $event)"
    >
      <SwiperSlide
        v-for="(item, index) in items"
        :key="item?.id"
        :data-media-type="item?.media?.type ?? ''"
      >
        <slot name="item" :item="item" :index="index"></slot>
      </SwiperSlide>
    </Swiper>
  </div>
</template>

<script setup lang="ts">
import type { AutoplayOptions, SwiperModule } from "swiper/types";
import { onMounted, ref, type PropType } from "vue";
import { Swiper, SwiperSlide } from "swiper/vue";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import "swiper/css/effect-fade";
interface INavigation {
  nextEl: string;
  prevEl: string;
}
const { t } = useI18n();
defineProps({
  class: { type: String },
  direction: {
    type: String as PropType<"horizontal" | "vertical" | undefined>,
  },
  modules: { type: Array<SwiperModule> },
  effect: {
    type: String as PropType<
      "slide" | "fade" | "cube" | "coverflow" | "flip" | "creative" | "cards"
    >,
  },
  navigation: {
    type: [Boolean, Object] as unknown as () => boolean | INavigation,
  },
  loop: { type: Boolean },
  spaceBetween: { type: Number },
  slidesPerView: { type: Number },
  autoplay: {
    type: Object as PropType<AutoplayOptions | boolean>,
  },
  breakpoints: {
    type: Object as PropType<any>,
  },
  mousewheel: {
    type: Object as PropType<any>,
  },
  pagination: {
    type: Object as PropType<any>,
  },
  items: { type: Object as PropType<Array<any>>, required: true },
  swiperBg: { type: String, default: "" },
  swiperStyle: {
    type: Object as PropType<Record<string, string>>,
    default: () => ({}),
  },
});
const isClient = ref(false);
const layoutSize = ref<number | null>(null);
onMounted(() => {
  isClient.value = true;
  const rootStyles = getComputedStyle(document.documentElement);
  const tmp = rootStyles.getPropertyValue("--layout-max-width").trim();
  layoutSize.value = parseInt(tmp);
});

const emit = defineEmits(["slide-change", "swiper"]);
</script>
